/**
 * Public (unauthenticated) portal pages.
 *
 * Route names MUST start with `public-` — App.vue's `isPublicMarketingRoute` keys off that
 * prefix to drop the in-app sidebar/header for anonymous visitors.
 *
 * Deliberately NOT gated: no `requiresAuth`, no `requiresEntitlement`, and no
 * `requiresFeatureFlag`. The water-risk feature flag in particular is email-domain gated,
 * so gating on it here would lock out every real visitor.
 */
import i18n from '@/i18n';

export default [
  {
    meta: {
      title: i18n.global.t('page_titles.water-risk'),
      requiresAuth: false,
      hideNewsletter: true,
      analytics: { toolId: 'water-risk', presence: true },
      // No breadcrumbs / favorites: both are authenticated surfaces.
      favoritable: false,
    },
    path: '/public/water-risk',
    name: 'public-water-risk',
    component: () => import('../../features/water-risk/pages/DashboardWaterRisk.vue'),
    props: { isPublic: true },
  },
  // Profiteia's published newsroom articles. `/n/{slug}` (backend share page with Open Graph
  // tags and the article text for crawlers) redirects people to the article route.
  {
    meta: {
      title: i18n.global.t('page_titles.newsroom_reader'),
      requiresAuth: false,
      hideNewsletter: true,
      favoritable: false,
    },
    path: '/public/nieuws',
    name: 'public-news',
    component: () => import('../../features/newsroom-reader/pages/NewsroomArticlesPage.vue'),
    props: { isPublic: true },
  },
  {
    meta: {
      title: i18n.global.t('page_titles.newsroom_reader'),
      requiresAuth: false,
      hideNewsletter: true,
      favoritable: false,
    },
    path: '/public/nieuws/:slug',
    name: 'public-news-article',
    component: () => import('../../features/newsroom-reader/pages/NewsroomArticlePage.vue'),
    props: { isPublic: true },
  },
];
